export default "__VITE_ASSET__d186119c__"